import {Paper, styled} from '@mui/material';

export const Container = styled('div')(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: theme.spacing(2),
  transition: '0.25s opacity ease-in-out',

  '&.loading': {
    opacity: 0.5,
    pointerEvents: 'none',
  },
}));

export const Buttons = styled('div')(({theme}) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 2),
}));

export const ReportContent = styled(Paper)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: theme.spacing(2),
  transition: '0.25s opacity ease-in-out',
}));

export const Blocks = styled('div')(({theme}) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  padding: theme.spacing(1),
}));

export const Break = styled('div')(() => ({
  flex: '0 0 100%',
  height: 0,
  width: '100%',
}));

export const Header = styled('h3')(({theme}) => ({
  color: theme.palette.primary.contrastText,
  fontSize: '1.4em',
  margin: 0,
  flex: '0 0 100%',
  padding: theme.spacing(0.5),
  textAlign: 'center',
  width: '100%',
}));

export const BlockContainer = styled('div')(({theme}) => ({
  display: 'flex',
  flex: `0 0 ${100 / 3}%`,
  flexDirection: 'column',
  padding: theme.spacing(1),
  textAlign: 'center',
  width: `${100 / 3}%`,

  '& > h3': {
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontSize: '1.4em',
    margin: 0,
    padding: theme.spacing(0.5),
  }
}));

export const BlockRow = styled('div')(() => ({
  display: 'flex',
}));

export const BlockColumn = styled('div')(({theme}) => {
  const border = `1px solid ${theme.palette.grey['300']}`;
  return {
    borderBottom: border,
    borderLeft: border,
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',

    '&:last-child': {
      borderRight: border,
    },

    '& > h4': {
      backgroundColor: theme.palette.grey['100'],
      flex: '0 0 100%',
      fontSize: '1.1em',
      margin: 0,
      padding: theme.spacing(0.5, 0),
      width: '100%',
    },

    '&.interactive': {
      '& > h4': {
        cursor: 'pointer',
        transition: '0.25s background-color ease-in-out',

        '&:hover': {
          backgroundColor: theme.palette.grey['200'],
        },
      }
    },

    '& > div': {
      flex: 1,

      '& > h5': {
        color: theme.palette.grey['500'],
        fontSize: '0.8em',
        margin: 0,
        padding: theme.spacing(0.5, 0),
      },

      '& > h6': {
        fontSize: '0.95em',
        margin: 0,
        padding: theme.spacing(0.5, 0),
      },
    },
  };
});
